import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { each, debounce } from 'lodash'

// components
import { Field } from 'redux-form'
import renderUserEditField from './render-field'
import SearchTypeahead from '../SearchTypeahead'

export default class BasicInfos extends Component {
  constructor(props) {
    super(props)

    this.onChange = this.onChange.bind(this)
    this.onInputChange = this.onInputChange.bind(this)
  }

  onChange = updatedGroups => {
    // Check for existing group in state for admin
    const isGroupAdmin = (user, group) => {
      if (user && user.Groups && user.Groups.length > 0) {
        const existingGroup = user.Groups.find(userGroup => userGroup.id === group.value)
        if (!existingGroup) return false
        return existingGroup.GroupUser ? existingGroup.GroupUser.isAdmin : false
      } else {
        return false
      }
    }
    const groupRoles = {}
    each(updatedGroups, group => {
      if (groupRoles[group.value]) {
        groupRoles[group.value].visible = true
      } else {
        groupRoles[group.value] = {
          visible: true,
          isAdmin: isGroupAdmin(this.props.userEdit, group),
          id: group.value,
          name: group.label,
          isActive: group.isActive
        }
      }
    })

    this.props.setBasicInfosState(groupRoles)
  }

  onInputChange = searchTerm => {
    this.fetchGroupsDebounce(searchTerm)
  }

  fetchGroupsDebounce = debounce(searchTerm => {
    this.props.fetchGroupSuggestions(searchTerm)
  }, 200)

  render() {
    const { id, userEdit, groupSuggestions } = this.props

    return (
      <div>
        <h3>BASIC INFORMATION</h3>
        <table>
          <tbody>
            <Field type="text" name="fullname" required component={renderUserEditField} label="Display Name" />
            {id === 'new' && <Field name="email" type="text" label="Email" component={renderUserEditField} />}
            {id && (
              <tr>
                <td>Groups</td>
                <td>
                  <SearchTypeahead
                    multiple
                    size={'large'}
                    justify={'left'}
                    disabled={false}
                    autoFocus={false}
                    labelKey={'label'}
                    placeholder={'Search Groups..'}
                    onChange={this.onChange}
                    onInputChange={this.onInputChange}
                    suggestions={getSelectableGroups(groupSuggestions)}
                    selectedValues={getSelectableGroups(userEdit.Groups)}
                  />
                </td>
                <td />
              </tr>
            )}
          </tbody>
        </table>
      </div>
    )
  }
}

BasicInfos.propTypes = {
  id: PropTypes.string,
  user: PropTypes.object,
  setBasicInfosState: PropTypes.func,
  groupRoles: PropTypes.object,
  groups: PropTypes.array,
  userEdit: PropTypes.object,
  fetchGroupSuggestions: PropTypes.func,
  groupSuggestions: PropTypes.array
}

export function getSelectableGroups(groups) {
  return (groups || []).reduce((acc, group) => {
    acc.push({
      value: group.id,
      label: group.name,
      disabled: !group.isActive,
      isActive: group.isActive,
      isPortalGroup: group.isPortalGroup,
      s3Bucket: group.s3Bucket
    })
    return acc
  }, [])
}
